<template>
  <v-menu
    ref="menu"
    v-model="show"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="currentValue"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :id="id"
        :label="label"
        v-model="currentValue"
        v-show="!hiddenField(access)"
        :required="requiredField(access)"
        readonly
        :prepend-icon="queryFlag ? null : 'mdi-clock-time-four-outline'"
        v-bind="attrs"
        v-on="on"
        :filled="readonlyField(access)"
        :rules="rules"
        autocomplete="off"
        :clearable="!queryFlag && (requiredField(access) || optionalField(access))"
        :outlined="queryFlag"
        :single-line="queryFlag"
        :hide-details="queryFlag"
        :dense="queryFlag"
        :style="queryFlag ? 'font-size: 0.9em' : null"
        @input="() => handleChange(null)"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="show"
      v-model="currentValue"
      full-width
      @click:minute="$refs.menu.save(currentValue)"
    ></v-time-picker>
  </v-menu>
  <!--
  <v-menu
    v-model="show"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :id="id"
        :label="label"
        v-model="currentValue"
        v-show="!hiddenField(access)"
        @input="() => handleChange(null)"
        :required="requiredField(access)"
        readonly
        :prepend-icon="queryFlag ? null : 'mdi-calendar'"
        v-bind="attrs"
        v-on="on"
        :filled="readonlyField(access)"
        :rules="rules"
        autocomplete="off"
        :clearable="!queryFlag && (requiredField(access) || optionalField(access))"
        :outlined="queryFlag"
        :single-line="queryFlag"
        :hide-details="queryFlag"
        :dense="queryFlag"
        :style="queryFlag ? 'font-size: 0.9em' : null"
      ></v-text-field>
    </template>
    <v-date-picker
      :locale="customLanguage"
      v-model="currentValue"
      v-if="!readonlyField(access)"
      @input="show = false"
      @show="handleShow"
    ></v-date-picker>
  </v-menu>
  -->
</template>

<script>
//import moment from 'moment';
export default {
  name: "TimeField",
  props: [
    "label",
    "value",
    "access",
    "pattern",
    "id",
    "name",
    "rules",
    "dataType",
    "customLanguage",
    "queryFlag",
    "customStyle",
    "coordinates"
  ],
  data() {
    return {
      defaultValue: this.value ? this.value.substr(0, 10) : null,
      currentValue: this.value ? this.value.substr(0, 10) : null,
      prevValue: this.value ? this.value.substr(0, 10) : null,
      show: false
    };
  },
  methods: {
    handleChange(autoSource) {
      if (this.currentValue != this.prevValue) {
        const data = {
          value: this.currentValue,
          id: this.id,
          autoSource,
          coordinates: this.coordinates
        };
        this.$emit("field-change", data);
      }
      this.prevValue = this.currentValue;
    },
    setValue(value, autoSource) {
      this.currentValue = value;
      this.handleChange(autoSource);
    },
    allCustomStyle() {

    },
    handleShow() {
    }
  },
  updated() {
    this.handleChange();
  },
};
</script>

<style scoped>
</style>